import React from "react";
import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ArtGallery from "../images/art-gallery.jpg"; // Import your artist image
import DigitalWoman from "../images/digital-old-woman-2025.jpg";
import GalleryInterior from "../images/gallery-interior-2025.jpg";
import WomanHeadDress from "../images/woman-head-dress-2025.jpg";
import Splash from "../components/Splash";

const Home = ({ user }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const hiddenElements = document.querySelectorAll(".slideUp");
    console.log("hidden elements", hiddenElements);

    const observerOptions = {
      root: null, // using the viewport as the root
      threshold: 0.2, // trigger when 50% of the target is visible
      rootMargin: "0px", // adjust this value to fine-tune when the observer triggers
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log("HomeShow", entry);
          entry.target.classList.add("show");
        } else {
          entry.target.classList.remove("show");
        }
      });
    }, observerOptions);

    hiddenElements.forEach((el) => observer.observe(el));

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, []); // Empty dependency array to run only on mount

  return (
    <>
      <Splash className='slideUp' />
      <Container id='targetSection' className='mt-3'>
        <Row className='mt-3 d-flex align-items-center'>
          <h1 className='whiteText'>Welcome</h1>
          <Col lg={{ span: 6, order: 1 }} className='whiteText slideUp'>
          <p>
  Exciting news! The Piermont Flywheel Gallery will soon welcome a new Guest Artist Showcase, giving selected artists the opportunity to exhibit their work in our gallery.
</p>
<p>
  Our member team will help participating artists organize their exhibition and promote the showcase, culminating in a reception celebrating their work and creativity.
</p>
<p>
  Dates and additional details will be announced soon.
</p>

          </Col>
          <Col lg={{ span: 6, order: 2 }} className='text-center slideUp'>
            <img
              src={GalleryInterior}
              alt='Artist Showcase'
              className='img-fluid'
            />
          </Col>
        </Row>

        <Row className='mt-3 d-flex align-items-center'>
          {/* Text first on small screens, second on large screens */}
          <Col
            lg={{ span: 6, order: 2 }} // Order 2 on large screens (below image)
            sm={{ span: 12, order: 1 }} // Order 1 on small screens (above image)
            className='whiteText mt-4 slideUp'
          >
            <h2>Grow as an Artist - Sell Your Work</h2>
            <p>
              You have control over your prices and keep 100% of your individual sales
              (minus credit card fees if applicable). There's a nominal fee to apply, and if you're selected, the one-time fee is just $450.
            </p>
            <p>
              Participating artists will take turns gallery sitting during their show,
              ensuring equal participation.
            </p>
            <p>
              We welcome all art forms and mediums, from classic paintings to innovative
              digital installations, fine art photography, mixed media, and
              three-dimensional artworks (sculpture, pottery, etc.).
            </p>
          </Col>

          {/* Image second on small screens, first on large screens */}
          <Col
            lg={{ span: 6, order: 1 }} // Order 1 on large screens (above text)
            sm={{ span: 12, order: 2 }} // Order 2 on small screens (below text)
            className='text-center slideUp'
          >
            <img src={DigitalWoman} alt='Artist Showcase' className='img-fluid' />
          </Col>
        </Row>

        <Row className='mt3 d-flex align-items-center'>
          <Col lg={{ span: 6, order: 1 }} sm={{ span: 12, order: 2 }} className='whiteText mt-4 slideUp'>
            <h2>Don't Miss Out</h2>
            <p>
              Guest Artist submissions are welcome at any time.
            </p>
            <p>
              Our gallery jury reviews work based on quality, medium, size, and
              available exhibition space. Selected artists will be contacted
              directly with details about upcoming showcase opportunities.
            </p>
            <p>
              Submit your work anytime to be considered for a future Guest
              Artist Showcase.
            </p>
            {!user && (
              <Button
                className='btn btn-primary mb-4'
                onClick={() => navigate("/Register")}>
                Register to Get Started
              </Button>
            )}
          </Col>

          <Col
            lg={{ span: 6, order: 2 }}  // Order 2 on large screens
            sm={{ span: 12, order: 1 }} // Order 1 on small screens (first)
            className='whiteText slideUp'
          >
            <img src={WomanHeadDress} alt='Artist Showcase' className='img-fluid' />
          </Col>
        </Row>

        <Row className='mt-3 d-flex align-items-left'>
          <Col lg={4} className='whiteText'></Col>
          <Col lg={4} className='whiteText'>
            {" "}
          </Col>
          <Col lg={4} className='whiteText'>
            {" "}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Home;
